// extracted by mini-css-extract-plugin
export default {"field":"CompanyDetails_field__6vvAa","heading":"CompanyDetails_heading__oOR0r"};